import {
  ApiBlueprint,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import { appsMonitorApiRef } from './AppsMonitorApi';
import { AppsMonitorClient } from './AppsMonitorClient';

export const appsMonitorApi = ApiBlueprint.make({
  name: 'apps-monitor',
  params: defineParams =>
    defineParams({
      api: appsMonitorApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new AppsMonitorClient(discoveryApi, fetchApi),
    }),
});

export { appsMonitorApiRef } from './AppsMonitorApi';
export type { AppsMonitorApi } from './AppsMonitorApi';
